import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

const categoryStyles: Record<NewsItem['category'], string> = {
  最新动态: 'bg-primary-100 text-primary-800',
  活动报道: 'bg-accent-100 text-accent-800',
  媒体采访: 'bg-secondary-200 text-secondary-900',
  作品发布: 'bg-foreground-900 text-background-100',
};

export function CategoryTag({ category }: { category: NewsItem['category'] }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${categoryStyles[category]}`}
    >
      {category}
    </span>
  );
}

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-200">
      <Link to={`/news/${item.id}`} className="block cursor-pointer">
        <div className="relative h-48 w-full overflow-hidden bg-background-200">
          <img
            src={item.thumb}
            alt={`${item.title} 配图`}
            title={`${item.title} 深田咏美资讯`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3">
            <CategoryTag category={item.category} />
          </span>
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="mb-2 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/news/${item.id}`} className="transition-colors group-hover:text-primary-700 cursor-pointer">
            {item.title}
          </Link>
        </h3>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-500">{item.summary}</p>
        <Link
          to={`/news/${item.id}`}
          className="mt-4 inline-flex w-fit items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
        >
          阅读全文
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </article>
  );
}